import { AuthService } from "../auth/services/auth.service"
import { Routes, type Route } from "./routes"

export class RouteGuardian {
  constructor(private _authService: AuthService) { }
 
  // VISITOR = Il ne peut qu'aller sur les pages visiteurs (login). 
  //           Si isVisitorRoute on le laisse passer, sinon on le redirige vers login.
  // FREE = Il ne peut qu'aller sur les pages gratuites.
  //        Si isFreeRoute on le laisse passer, sinon le redirige vers account-settings.
  //        Si isVisitorRoute on le laisse pas passer.
  // PREMIUM = Toujours ok, sauf si isVisitorRoute on le laisse pas passer.
  async onRouteEntered(route: Route = window.location.pathname) {
    await this._authService.checkAuth()

    if (this._authService.isVisitor) {
      if (Routes.isVisitorRoute(route)) { return true }

      Routes.redirectToAuth()
      return false
    }

    if (this._authService.isFreemium) {
      if (Routes.isUserFreeRoute(route)) { return true }

      Routes.redirectToAccount()
      return false
    }

    if (this._authService.isPremium) {
      if (Routes.isVisitorRoute(route)) { Routes.redirectToPrevious(); return false }

      return true
    }

    return true
  }
}
